import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import TabToolbar from '../../../components/styled/TabToolbar';
import { useTranslation } from '../../../../../../i18n/useTranslation';

type DescriptionPreviewToolbarProps = {
    onEdit: () => void;
};

export const DescriptionPreviewToolbar = ({ onEdit }: DescriptionPreviewToolbarProps) => {
    const { t } = useTranslation();

    return (
        <TabToolbar>
            <Button type="default" onClick={onEdit}>
                <EditOutlined /> {t('Edit')}
            </Button>
        </TabToolbar>
    );
};
